export default "__VITE_ASSET__DrFYfnfS__"